import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalService } from '../../services/modal.service';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-trabaja-con-nosotros',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './trabaja-con-nosotros.component.html',
  styleUrls: ['./trabaja-con-nosotros.component.css']
})
export class TrabajaConNosotrosComponent {
  
  trabajaForm: FormGroup;
  isLoading: boolean = false;
  dropdownOpen: boolean = false;
  
  puestoSeleccionadoLabel: string = 'Seleccionar';
  nombreArchivoSeleccionado: string = 'Adjuntar archivo*';

  especialidades: string[] = [
    'Geología', 'Hidrología', 'Mecánica de fluidos', 'Ingeniería Hidráulica', 
    'Electricidad Industrial y Automatización', 'Mecánica de mantenimiento y soldadura en sistema de fluidos', 
    'Perforación de pozos tubulares'
  ];

  puestos = [
    { value: 'geologia', label: 'Geología' }, { value: 'hidrologia', label: 'Hidrología' },
    { value: 'mecanica-fluidos', label: 'Mecánica de fluidos' }, { value: 'ingenieria-hidraulica', label: 'Ingeniería Hidráulica' },
    { value: 'electricidad-industrial', label: 'Electricidad Industrial y Automatización' },
    { value: 'mecanica-mantenimiento', label: 'Mecánica de mantenimiento y soldadura' },
    { value: 'perforacion-pozos', label: 'Perforación de pozos tubulares' }, { value: 'otro', label: 'Otro' }
  ];

  constructor(
    private fb: FormBuilder, 
    private modalService: ModalService,
    private http: HttpClient
  ) {
    this.trabajaForm = this.fb.group({
      nombre: ['', [Validators.required, Validators.maxLength(255)]],
      email: ['', [Validators.required, Validators.email, Validators.maxLength(255)]],
      telefono: ['', [Validators.required, Validators.maxLength(20)]],
      carrera: ['', [Validators.required, Validators.maxLength(255)]],
      puesto: ['', [Validators.required]],
      cv: [null, [Validators.required]]
    });
  }

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  seleccionarPuesto(puesto: any) {
    this.trabajaForm.patchValue({ puesto: puesto.value });
    this.puestoSeleccionadoLabel = puesto.label;
    this.dropdownOpen = false;
  }

  onFileSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      if (file.size > 5 * 1024 * 1024) {
        this.modalService.open({ title: 'Archivo Pesado', message: 'El archivo es demasiado pesado. Máximo 5MB.', isError: true });
        event.target.value = ''; // Clear the input
        return;
      }
      
      this.trabajaForm.patchValue({ cv: file });
      this.trabajaForm.get('cv')?.updateValueAndValidity();
      this.nombreArchivoSeleccionado = file.name;
    }
  }

  onSubmit() {
    if (this.trabajaForm.invalid) {
      this.trabajaForm.markAllAsTouched();
      // Inform user about the invalid form
      this.modalService.open({title: 'Formulario Incompleto', message: 'Por favor, complete todos los campos requeridos.', isError: true});
      return;
    }

    this.isLoading = true;
    
    const formData = new FormData();
    formData.append('nombre', this.trabajaForm.get('nombre')?.value);
    formData.append('email', this.trabajaForm.get('email')?.value);
    formData.append('telefono', this.trabajaForm.get('telefono')?.value);
    formData.append('carrera', this.trabajaForm.get('carrera')?.value);
    formData.append('puesto', this.trabajaForm.get('puesto')?.value);
    // Use 'cv_archivo' to match the PHP script
    formData.append('cv_archivo', this.trabajaForm.get('cv')?.value);

    const url = 'https://corporacionrehobot.com/php/api/postular.php';

    this.http.post<any>(url, formData).pipe(
      finalize(() => {
        this.isLoading = false;
      })
    ).subscribe({
      next: (response) => {
        if (response.status === 'success') {
          this.modalService.open({ title: '¡Éxito!', message: '¡Postulación enviada con éxito! Gracias por tu interés.' });
          this.trabajaForm.reset();
          this.puestoSeleccionadoLabel = 'Seleccionar';
          this.nombreArchivoSeleccionado = 'Adjuntar archivo*';
        } else {
          this.modalService.open({ title: 'Error del Servidor', message: response.message || 'Ocurrió un error al procesar tu postulación.', isError: true });
        }
      },
      error: (err: HttpErrorResponse) => {
        console.error('Error real:', err);
        this.modalService.open({ title: 'Error de Conexión', message: 'No se pudo enviar la postulación. Por favor, intente de nuevo más tarde.', isError: true });
      }
    });
  }
}
